<template>
  <div class="forum-wrapper">
    <div class="forum-layout">
      <div class="main-column">
        <header class="admin-header">
          <h1 class="typo-headline-4">Panel de Administración</h1>
        </header>
        <div class="admin-content">
          <div class="admin-menu">
            <div class="menu-section">
              <h2 class="section-title">Gestión de Contenido</h2>
              <div class="menu-items">
                <router-link :to="{ name: 'AdminNeedResponse' }" class="menu-item">
                  <i class="material-icons">help_outline</i>
                  <div class="item-details">
                    <span class="item-title">Mensajes que Necesitan Respuesta</span>
                    <span class="item-description">Gestionar mensajes marcados como necesitan respuesta</span>
                  </div>
                  <!-- Display loading indicator while fetching -->
                  <div class="item-count" v-if="loading">...</div>
                  <div class="item-count" v-else>{{ needResponseCount }}</div>
                </router-link>

                <router-link :to="{ name: 'AdminReports' }" class="menu-item">
                  <i class="material-icons">flag</i>
                  <div class="item-details">
                    <span class="item-title">Reportes Pendientes</span>
                    <span class="item-description">Revisar y gestionar reportes de usuarios</span>
                  </div>
                   <!-- Display loading indicator while fetching -->
                  <div class="item-count" v-if="loading">...</div>
                  <div class="item-count" v-else>{{ reportsCount }}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="side-column">
        <user-activity-widget />
        <navigation-links />
      </div>
    </div>
  </div>
</template>

<script>
import forumApi from '@/services/forumApi';
const axios = forumApi;
import UserActivityWidget from '../components/UserActivityWidget.vue';
import NavigationLinks from '../components/NavigationLinks.vue';

export default {
  name: 'AdminPanel',
  components: {
    UserActivityWidget,
    NavigationLinks
  },
  data() {
    return {
      needResponseCount: 0,
      reportsCount: 0,
      loading: true // Set initial loading state
    };
  },
  mounted() {
    this.fetchCounts();
  },
  watch: {
    // Watch the route name
    '$route.name'(toName) {
      // If we navigate *to* this component, refresh the counts
      if (toName === 'AdminPanel') {
        this.fetchCounts();
      }
    }
  },
  methods: {
    fetchCounts() {
      this.loading = true; // Set loading state before fetching
      // Fetch need response count
      axios.get('/forum/api/need-response/get', {
        params: {
          count_only: true
        }
      })
      .then(response => {
        if (response.data && response.data.success && response.data.pagination && response.data.pagination.total) {
          const totalTopics = response.data.pagination.total.topics || 0;
          const totalComments = response.data.pagination.total.comments || 0;
          this.needResponseCount = totalTopics + totalComments;
        } else {
           this.needResponseCount = 0; // Reset on error or invalid data
           console.error('Invalid data structure received for need response count:', response.data);
        }
      })
      .catch(error => {
        console.error('Error fetching need response count:', error);
        this.needResponseCount = 0; // Reset on error
      })
      .finally(() => {
         // For now, reports count is just 0
         // In a real scenario, fetch this count too, perhaps in parallel (Promise.all)
         this.reportsCount = 0;
         this.loading = false; // Reset loading state after fetching
      });
    }
  }
};
</script>

<style scoped>
.forum-wrapper {
  background-color: var(--color-background);
  min-height: 100vh;
  padding: 40px 20px;
}

.forum-layout {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 20px;
}

.main-column {
  flex: 3;
  color: var(--color-text-primary);
}

.side-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.admin-header {
  margin-bottom: 20px;
  padding: 20px;
  background-color: var(--color-surface);
  border-radius: 15px 15px 0 0;
  text-align: center;
}

.admin-header h1 {
  margin: 0;
}

.admin-content {
  background-color: var(--color-surface);
  padding: 20px;
  border-radius: 0 0 15px 15px;
}

.menu-section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 1.2rem;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--color-outline);
}

.menu-items {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 15px;
  background-color: var(--color-background);
  border-radius: 8px;
  text-decoration: none;
  color: var(--color-text-primary);
  transition: background-color 0.3s ease;
}

.menu-item:hover {
  background-color: var(--color-active-surface);
}

.menu-item i {
  font-size: 24px;
  margin-right: 15px;
  color: var(--color-highlight);
}

.item-details {
  flex: 1;
}

.item-title {
  display: block;
  font-weight: 500;
  margin-bottom: 5px;
}

.item-description {
  display: block;
  font-size: 0.9rem;
  color: var(--color-text-secondary);
}

.item-count {
  background-color: var(--color-highlight);
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 500;
  min-width: 24px;
  text-align: center;
}

@media (max-width: 768px) {
  .forum-layout {
    flex-direction: column;
  }

  .main-column,
  .side-column {
    width: 100%;
  }

  .side-column {
    margin-top: 20px;
  }
}
</style>